module.exports = __webpack_public_path__ + "static/media/rewards_recognitions_logo.148a61d0.svg";